export const IsArraysEqual = (array1: any[], array2: any[]) => {
  if (!array1 || !array2) {
    return false;
  }
  return array1.length === array2.length && array1.every((value, index) => value === array2[index]);
};

export function SortByProp<T>(list: T[], prop: keyof T, asNumber = false): T[] {
  if (!list) {
    return list;
  }
  if (asNumber) {
    return list.sort((a, b) => +a[prop] - +b[prop]);
  }
  console.log(list);
  return list.sort((a, b) => {
    if (a[prop] && b[prop]) {
      return a[prop] ? a[prop].toString().localeCompare(b[prop].toString()) : 0;
    } else {
      return 0;
    }
  });
}

export function UniqArray<T>(list: T[], prop: string): T[] {
  return list.filter((value, index, array) => {
    return array.findIndex(item => item[prop] === value[prop]) === index;
  });
}

export function UniqArrayPreferLast<T>(list: T[], prop: string): T[] {
  const findLastIndex = (arr: T[], propName: string, value: any) => {
    let i = arr.length;
    while (i--) {
      if (arr[i][propName] === value) {
        return i;
      }
    }
    return -1;
  }
  return list.filter((value, index, array) => {
    return findLastIndex(array, prop, value[prop]) === index;
  });
}

export function SliceArayIntoChunks(arr, chunkSize) {
  const res = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    res.push(chunk);
  }
  return res;
}

export function removeDuplicates(array: any[], uniqField = 'id') {
  const uniqIds = new Set(array.map(p => p[uniqField]));
  return Array.from(uniqIds).map(id => array.find(el => el[uniqField] === id));
}
